import script from "./manage_prosthesis_sub.vue?vue&type=script&setup=true&lang=js"
export * from "./manage_prosthesis_sub.vue?vue&type=script&setup=true&lang=js"

import "./manage_prosthesis_sub.vue?vue&type=style&index=0&id=418e2e42&lang=css"

const __exports__ = script;

export default __exports__